document.addEventListener('DOMContentLoaded',()=>{
 const h=document.querySelector('[data-site-header]'),menu=document.querySelector('[data-menu-panel]'),search=document.querySelector('[data-search-panel]');
 const closeAll=()=>{if(menu)menu.hidden=true;if(search)search.hidden=true;h?.classList.remove('is-open')};
 document.querySelector('[data-menu-open]')?.addEventListener('click',()=>{const open=menu.hidden;closeAll();menu.hidden=!open;h.classList.toggle('is-open',open)});
 document.querySelector('[data-menu-close]')?.addEventListener('click',closeAll);
 document.querySelector('[data-search-open]')?.addEventListener('click',()=>{const open=search.hidden;closeAll();search.hidden=!open;h.classList.toggle('is-open',open);if(open)search.querySelector('input')?.focus()});
 document.querySelector('[data-search-close]')?.addEventListener('click',closeAll);
 if(h?.classList.contains('site-header--overlay')){const syncHeaderScroll=()=>h.classList.toggle('is-scrolled',window.scrollY>1);syncHeaderScroll();window.addEventListener('scroll',syncHeaderScroll,{passive:true});}
 document.querySelectorAll('[data-collection-blocks]').forEach(s=>{const blocks=[...s.querySelectorAll('[data-collection-block]')],initial=+s.dataset.initial||3,btn=s.querySelector('[data-load-blocks]');blocks.forEach((b,i)=>b.classList.toggle('is-hidden',i>=initial));btn?.addEventListener('click',()=>{const hidden=blocks.filter(b=>b.classList.contains('is-hidden'));hidden.slice(0,initial).forEach(b=>b.classList.remove('is-hidden'));if(hidden.length<=initial)btn.remove()})});
 document.querySelectorAll('[data-map-stage]').forEach(stage=>{const world=stage.querySelector('[data-map-world]');let x=0,y=0,z=1,drag=false,sx=0,sy=0,bx=0,by=0;const draw=()=>world.style.transform=`translate(calc(-50% + ${x}px),calc(-50% + ${y}px)) scale(${z})`;stage.addEventListener('pointerdown',e=>{if(e.target.closest('[data-pin]'))return;drag=true;sx=e.clientX;sy=e.clientY;bx=x;by=y;stage.setPointerCapture(e.pointerId)});stage.addEventListener('pointermove',e=>{if(!drag)return;x=bx+e.clientX-sx;y=by+e.clientY-sy;draw()});stage.addEventListener('pointerup',()=>drag=false);stage.addEventListener('wheel',e=>{e.preventDefault();z=Math.max(.7,Math.min(2.2,z+(e.deltaY<0?.12:-.12)));draw()},{passive:false});
 });
});

/* V18 — mobile product info reveal on touch / horizontal scroll */
(function(){
  function initEditorialMeta(){
    if(!window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('.product-strip--editorial').forEach(function(strip){
      if(strip.dataset.metaRevealReady==='true') return;
      strip.dataset.metaRevealReady='true';
      var cards=Array.prototype.slice.call(strip.querySelectorAll('.product-card'));
      if(!cards.length) return;
      var raf=0;
      function revealNearest(){
        cancelAnimationFrame(raf);
        raf=requestAnimationFrame(function(){
          var box=strip.getBoundingClientRect();
          var targetX=Math.max(box.left,0)+Math.min(box.width,window.innerWidth)/2;
          var nearest=null,dist=Infinity;
          var maxScroll=Math.max(0,strip.scrollWidth-strip.clientWidth);
          var edgeThreshold=6;

          /* Keep V18's exact layout, but let the edge products become active
             at the natural beginning/end of the strip instead of requiring
             an exaggerated overscroll toward the center reveal zone. */
          if(strip.scrollLeft<=edgeThreshold){
            nearest=cards[0];
          }else if(maxScroll-strip.scrollLeft<=edgeThreshold){
            nearest=cards[cards.length-1];
          }else{
            cards.forEach(function(card){
              var r=card.getBoundingClientRect();
              var d=Math.abs((r.left+r.right)/2-targetX);
              if(r.right>0 && r.left<window.innerWidth && d<dist){nearest=card;dist=d;}
            });
          }
          cards.forEach(function(card){card.classList.toggle('is-meta-visible',card===nearest);});
        });
      }
      strip.addEventListener('scroll',revealNearest,{passive:true});
      strip.addEventListener('touchstart',function(e){
        var card=e.target.closest('.product-card');
        if(card && strip.contains(card)){
          cards.forEach(function(c){c.classList.toggle('is-meta-visible',c===card);});
        }
      },{passive:true});
      window.addEventListener('resize',revealNearest,{passive:true});
      revealNearest();
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initEditorialMeta);
  else initEditorialMeta();
  document.addEventListener('shopify:section:load',initEditorialMeta);
})();


/* V29 — reliable cart quantity updates */
(function(){
  function initCartQuantityUpdates(){
    document.querySelectorAll('[data-cart-quantity]').forEach(function(select){
      if(select.dataset.cartQuantityReady === 'true') return;
      select.dataset.cartQuantityReady = 'true';
      select.addEventListener('change', async function(){
        var key = select.getAttribute('data-line-key');
        var quantity = parseInt(select.value, 10);
        if(!key || isNaN(quantity)) return;
        select.disabled = true;
        try {
          var response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {'Content-Type':'application/json','Accept':'application/json'},
            body: JSON.stringify({id:key, quantity:quantity})
          });
          if(!response.ok) throw new Error('Cart update failed');
          var cart = await response.json();
          var headerCart = document.querySelector('[data-header-cart-count]');
          if(headerCart){ var countText = headerCart.querySelector('[data-cart-count-value]'); var countMobile = headerCart.querySelector('[data-cart-count-mobile]'); if(countText) countText.textContent = cart.item_count; if(countMobile) countMobile.textContent = cart.item_count; headerCart.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' items'); }
          /* Reload the cart markup from Shopify so line totals, subtotal,
             taxes/shipping rows and any discounts are always authoritative. */
          window.location.reload();
        } catch(err) {
          select.disabled = false;
          console.error(err);
          window.location.reload();
        }
      });
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCartQuantityUpdates);
  else initCartQuantityUpdates();
  document.addEventListener('shopify:section:load', initCartQuantityUpdates);
})();

/* V42 — force homepage header solid as soon as the page scrolls */
(function(){
  function initV42Header(){
    var header = document.querySelector('[data-site-header]');
    var wrapper = document.getElementById('shopify-section-header');
    if(!header || !header.classList.contains('site-header--overlay')) return;

    function getScrollTop(){
      return Math.max(
        window.pageYOffset || 0,
        document.documentElement ? document.documentElement.scrollTop || 0 : 0,
        document.body ? document.body.scrollTop || 0 : 0
      );
    }

    function sync(){
      var scrolled = getScrollTop() > 2;
      header.classList.toggle('is-scrolled', scrolled);
      if(wrapper) wrapper.classList.toggle('header-wrapper--scrolled', scrolled);
    }

    sync();
    window.addEventListener('scroll', sync, {passive:true});
    document.addEventListener('scroll', sync, {passive:true, capture:true});
    window.addEventListener('touchmove', sync, {passive:true});
    window.addEventListener('resize', sync, {passive:true});
    setTimeout(sync, 50);
    setTimeout(sync, 250);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initV42Header);
  else initV42Header();
  document.addEventListener('shopify:section:load', initV42Header);
})();
